// extracted by mini-css-extract-plugin
export default {"color_strip":"ColorStrip_color_strip__CpdVx","color_option":"ColorStrip_color_option__g2srs"};